export const getQueryString = () => {
  return '' || window.location.search;
};

export const getUserNameFromQuery = () => {
  const queryString = getQueryString();
  if (queryString.indexOf('LoginHint') > -1) {
    return decodeURIComponent(queryString.split('LoginHint=')[1].split('&')[0]);
  } else if (queryString.indexOf('idp_login_hint') > -1) {
    return decodeURIComponent(queryString.split('idp_login_hint=')[1].split('&')[0]);
  }
  return '';
};